<template>
    <div :class="{section: true, angels: true, mobile: mobile()}">
        <img class="hill hill1" src="@/assets/christmas/redHill.svg">
        <img class="hill hill2" src="@/assets/christmas/redHill.svg">
        <img class="grass" src="@/assets/christmas/grass2.svg">
        <img class="angelsImg" src="@/assets/christmas/angels.svg">
        <div class="ground"></div>
        <p class="text">Engel erscheinen Schafhirten in der Nähe und erzählen, dass jetzt gerade der Retter der Welt geboren wurde.</p>
    </div>
</template>

<script>
    import Vue from 'vue'
    import Component from 'vue-class-component'
    import BasicComponent from "@/components/BasicComponent";

    @Component()
    export default class Angels extends BasicComponent {

        onActive() {

        }

        mounted() {
            this.register();
        }



    }
</script>
<style scoped lang="scss">
    @import "@/stylesheets/Christmas.scss";

    .angels {

        position: relative;

        background-color: $backgroundBlue;

        .grass {
            max-height: 8vh;
            max-width: 5vw;

            position: absolute;
            bottom: $groundHeight;
            left: 20%;
            transform: translateX(-50%);
        }

        .angelsImg {
            max-height: calc(90vh - #{$groundHeight});
            max-width: 50vw;
            position: absolute;
            bottom: $groundHeight;
            right: 35%;
            transform: translateX(50%);
        }

        .text {
            text-align: left;
            width: 300px;
            max-width: 35vw;
            position: absolute;
            top: 25vh;
            left: 15%;
            font-weight: normal;
            font-size: 1.6em;
            color: black;
        }

    }


    .mobile {

        .angelsImg {
            max-width: 80vw;
            width: 80vw;
            right: 10vw;
            max-height: 40vh;
            transform: none;
            bottom: $mobileGroundHeight
        }

    }

</style>
